import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Ndg } from 'src/app/model/ndg';
import { SurveyForList } from 'src/app/model/survey-response';
import { SurveyService } from '../service/survey.service';
import { MessageService } from 'src/app/service/message.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NdgDataEmit, SurveyNeedsEmit } from 'src/app/model/survey-emits';

@Component({
  selector: 'new-survey',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss']
})
export class NewComponent {
  @Input() ndg!: Ndg;
  @Input() external: boolean = false;
  @Output() completed = new EventEmitter<SurveyForList>();

  formGroup = new FormGroup({});

  selectedTab: number = 0;
  surveyId!: string;
  
  ndgDataEmit!: NdgDataEmit;
  surveyNeedsEmit!: SurveyNeedsEmit;
  
  savingsCompleted: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  
  onSelectedTabChange(event: MatTabChangeEvent): void {
    event.tab.disabled = false;
  }

  onNdgDataComplete(ndgData: NdgDataEmit) {
    this.surveyId = ndgData.surveyId;
    this.ndgDataEmit = ndgData;
    this.selectedTab++;
  }

  onNeedsComplete(event: SurveyNeedsEmit) {
    this.surveyNeedsEmit = event;
    this.selectedTab++;
  }

  onProtectionComplete() {
    this.selectedTab++;
  }

  onSavingsComplete() {
    this.savingsCompleted = true;
    this.selectedTab++;
  }

  onSavingsShortListComplete() {
    this.selectedTab++;
  }

  onPrevidenceComplete() {
    this.selectedTab++;
  }

  onSurveyCompleted(surveyInfo: SurveyForList) {
    this.messageService.success('survey.new.message.success', { surveyId: surveyInfo.surveyId });
    this.completed.emit(surveyInfo);

    if(!this.external) {
      // Notify observable to update survey list
      this.surveyService.$newSurvey.next(surveyInfo);

      // Route to new created survey
      this.router.navigate(['../' + surveyInfo.surveyId], {relativeTo: this.route});
    }
  }
}
